module.exports = __webpack_public_path__ + "img/information_ethical_mob@2x.b10cc7a.jpg";